import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Typography, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Paper
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const ConflictDialog = ({ open, conflictData, onOverwrite, onCancel }) => {
    if (!conflictData) return null;

    const { edit, serverChanges } = conflictData;
    const changes = serverChanges || [];

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="md" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'warning.main' }}>
                <WarningAmberIcon />
                Edit Conflict Detected
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Someone else has modified this record since you started editing.
                    Review the changes below and decide whether to overwrite or cancel your edit.
                </Typography>

                {changes.length > 0 && (
                    <TableContainer component={Paper} variant="outlined" sx={{ mb: 2 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Field</TableCell>
                                    <TableCell>Their Value</TableCell>
                                    <TableCell>Changed By</TableCell>
                                    <TableCell>Changed At</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {changes.map((change, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell sx={{ fontWeight: 500 }}>{change.field}</TableCell>
                                        <TableCell>{change.newValue || '(empty)'}</TableCell>
                                        <TableCell>{change.editedBy || '---'}</TableCell>
                                        <TableCell>
                                            {change.editedAt
                                                ? new Date(change.editedAt).toLocaleString()
                                                : '---'}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                {edit && (
                    <Typography variant="body2" color="text.secondary">
                        <strong>Your changes:</strong>{' '}
                        {Object.entries(edit.changes || {}).map(([k, v]) => `${k}: "${v}"`).join(', ')}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="inherit">
                    Cancel My Edit
                </Button>
                <Button onClick={onOverwrite} variant="contained" color="warning">
                    Overwrite
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConflictDialog;
